/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useTranslation } from "react-i18next";
import StringUtil from "../../Utils/StringUtil"
import ValueType from "../ValueType";

export type TValueFunction = (value: any, valueType: ValueType) => string;

export default function useValueTranslation(): TValueFunction {
    const { t } = useTranslation("i18nBasis");
    return (value: any, valueType: ValueType) => {
        return t(`valueType.${StringUtil.toCamelCase(valueType)}`, { value });
    }
}
